export default {
  priority: 1,
  path: "assignment",
  permissions: ["TimeAttendanceMenu/ShiftMenu/ShiftAssignMenu"],
  // component: Definition,
  component: load(() =>
    import(/* webpackChunkName: "Shift-Definition" */ "./Report")
  ),
  name: app.translate("گزارش گیری"),
  icon: "account-check",
  drawer: true,
};
